import { IDeleteMultipleBaseRequest } from '../../../models/request/base/deleteRequest';
import { IBusTuyenDuongSelectRequest } from '../../../models/request/bus/busBaoCaoDiemDanhRequest';
import { IUploadExcelRequest } from '../../../models/request/bus/uploadExcelRequest';
import { BusLaiXeItemResponse } from '../../../models/response/bus/bus_laixe';
import { BusMonitoringItemResponse } from '../../../models/response/bus/bus_monitoring';
import { bus_tuyenduong, BusTuyenDuongItemResponse } from '../../../models/response/bus/bus_tuyenduong';
import { BusXeItemResponse } from '../../../models/response/bus/bus_xe';

export enum eBusTuyenDuongActionTypeIds {
	LOAD_START = "BUS_TUYENDUONG_LOAD_START",
	LOAD_SUCCESS = "BUS_TUYENDUONG_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_TUYENDUONG_LOAD_ERROR",

	LOAD_XE_START = "BUS_TUYENDUONG_LOAD_XE_START",
	LOAD_XE_SUCCESS = "BUS_TUYENDUONG_LOAD_XE_SUCCESS",
	LOAD_XE_ERROR = "BUS_TUYENDUONG_LOAD_XE_ERROR",

	LOAD_LAIXE_START = "BUS_TUYENDUONG_LOAD_LAIXE_START",
	LOAD_LAIXE_SUCCESS = "BUS_TUYENDUONG_LOAD_LAIXE_SUCCESS",
	LOAD_LAIXE_ERROR = "BUS_TUYENDUONG_LOAD_LAIXE_ERROR",

	LOAD_MONITORING_START = "BUS_TUYENDUONG_LOAD_MONITORING_START",
	LOAD_MONITORING_SUCCESS = "BUS_TUYENDUONG_LOAD_MONITORING_SUCCESS",
	LOAD_MONITORING_ERROR = "BUS_TUYENDUONG_LOAD_MONITORING_ERROR",

	SHOW_DETAIL = "BUS_TUYENDUONG_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_TUYENDUONG_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "BUS_TUYENDUONG_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "BUS_TUYENDUONG_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_TUYENDUONG_CLOSE_CONFIRM",

	SAVE_START = "BUS_TUYENDUONG_SAVE_START",
	SAVE_SUCCESS = "BUS_TUYENDUONG_SAVE_SUCCESS",
	SAVE_ERROR = "BUS_TUYENDUONG_SAVE_ERROR",

	DELETE_START = "BUS_TUYENDUONG_DELETE_START",
	DELETE_SUCCESS = "BUS_TUYENDUONG_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_TUYENDUONG_DELETE_ERROR",

	SHOW_IMPORT_MODAL = "BUS_TUYENDUONG_SHOW_IMPORT_MODAL",
	CLOSE_IMPORT_MODAL = "BUS_TUYENDUONG_CLOSE_IMPORT_MODAL",

	VALIDATE_IMPORT_START = "BUS_TUYENDUONG_VALIDATE_IMPORT_START",
	VALIDATE_IMPORT_SUCCESS = "BUS_TUYENDUONG_VALIDATE_IMPORT_SUCCESS",
	VALIDATE_IMPORT_ERROR = "BUS_TUYENDUONG_VALIDATE_IMPORT_ERROR",

	IMPORT_START = "BUS_TUYENDUONG_IMPORT_START",
	IMPORT_SUCCESS = "BUS_TUYENDUONG_IMPORT_SUCCESS",
	IMPORT_ERROR = "BUS_TUYENDUONG_IMPORT_ERROR"
}

export interface IBusTuyenDuongLoadStart {
	type: eBusTuyenDuongActionTypeIds.LOAD_START,
	payload: IBusTuyenDuongSelectRequest
}
export interface IBusTuyenDuongLoadSuccess {
	type: eBusTuyenDuongActionTypeIds.LOAD_SUCCESS,
	payload: BusTuyenDuongItemResponse[]
}
export interface IBusTuyenDuongLoadErr {
	type: eBusTuyenDuongActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusTuyenDuongLoadXeStart {
	type: eBusTuyenDuongActionTypeIds.LOAD_XE_START,
	payload: number
}
export interface IBusTuyenDuongLoadXeSuccess {
	type: eBusTuyenDuongActionTypeIds.LOAD_XE_SUCCESS,
	payload: BusXeItemResponse[]
}
export interface IBusTuyenDuongLoadXeErr {
	type: eBusTuyenDuongActionTypeIds.LOAD_XE_ERROR,
	payload: string
}
export interface IBusTuyenDuongLoadLaiXeStart {
	type: eBusTuyenDuongActionTypeIds.LOAD_LAIXE_START,
	payload: number
}
export interface IBusTuyenDuongLoadLaiXeSuccess {
	type: eBusTuyenDuongActionTypeIds.LOAD_LAIXE_SUCCESS,
	payload: BusLaiXeItemResponse[]
}
export interface IBusTuyenDuongLoadLaiXeErr {
	type: eBusTuyenDuongActionTypeIds.LOAD_LAIXE_ERROR,
	payload: string
}
export interface IBusTuyenDuongLoadMonitoringStart {
	type: eBusTuyenDuongActionTypeIds.LOAD_MONITORING_START,
	payload: number
}
export interface IBusTuyenDuongLoadMonitoringSuccess {
	type: eBusTuyenDuongActionTypeIds.LOAD_MONITORING_SUCCESS,
	payload: BusMonitoringItemResponse[]
}
export interface IBusTuyenDuongLoadMonitoringErr {
	type: eBusTuyenDuongActionTypeIds.LOAD_MONITORING_ERROR,
	payload: string
}
export interface IBusTuyenDuongShowDetail {
	type: eBusTuyenDuongActionTypeIds.SHOW_DETAIL,
	payload?: BusTuyenDuongItemResponse
}
export interface IBusTuyenDuongCloseDetail {
	type: eBusTuyenDuongActionTypeIds.CLOSE_DETAIL
}
export interface IBusTuyenDuongChangeSelectedIds {
	type: eBusTuyenDuongActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusTuyenDuongShowConfirm {
	type: eBusTuyenDuongActionTypeIds.SHOW_CONFIRM
}
export interface IBusTuyenDuongCloseConfirm {
	type: eBusTuyenDuongActionTypeIds.CLOSE_CONFIRM
}
export interface IBusTuyenDuongSaveStart {
	type: eBusTuyenDuongActionTypeIds.SAVE_START,
	payload: bus_tuyenduong
}
export interface IBusTuyenDuongSaveSuccess {
	type: eBusTuyenDuongActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IBusTuyenDuongSaveErr {
	type: eBusTuyenDuongActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IBusTuyenDuongDeleteStart {
	type: eBusTuyenDuongActionTypeIds.DELETE_START,
	payload: IDeleteMultipleBaseRequest
}
export interface IBusTuyenDuongDeleteSuccess {
	type: eBusTuyenDuongActionTypeIds.DELETE_SUCCESS
}
export interface IBusTuyenDuongDeleteErr {
	type: eBusTuyenDuongActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusTuyenDuongShowImportModal {
	type: eBusTuyenDuongActionTypeIds.SHOW_IMPORT_MODAL
}
export interface IBusTuyenDuongCloseImportModal {
	type: eBusTuyenDuongActionTypeIds.CLOSE_IMPORT_MODAL
}
export interface IBusTuyenDuongValidateImportStart {
	type: eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_START,
	payload: IUploadExcelRequest
}
export interface IBusTuyenDuongValidateImportSuccess {
	type: eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_SUCCESS,
	payload: any[]
}
export interface IBusTuyenDuongValidateImportErr {
	type: eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_ERROR,
	payload: string
}
export interface IBusTuyenDuongImportStart {
	type: eBusTuyenDuongActionTypeIds.IMPORT_START,
	payload: IUploadExcelRequest
}
export interface IBusTuyenDuongImportSuccess {
	type: eBusTuyenDuongActionTypeIds.IMPORT_SUCCESS
}
export interface IBusTuyenDuongImportErr {
	type: eBusTuyenDuongActionTypeIds.IMPORT_ERROR,
	payload: string
}

export type IBusTuyenDuongActionTypes = IBusTuyenDuongLoadStart | IBusTuyenDuongLoadSuccess | IBusTuyenDuongLoadErr |
	IBusTuyenDuongLoadXeStart | IBusTuyenDuongLoadXeSuccess | IBusTuyenDuongLoadXeErr |
	IBusTuyenDuongLoadLaiXeStart | IBusTuyenDuongLoadLaiXeSuccess | IBusTuyenDuongLoadLaiXeErr |
	IBusTuyenDuongLoadMonitoringStart | IBusTuyenDuongLoadMonitoringSuccess | IBusTuyenDuongLoadMonitoringErr |
	IBusTuyenDuongShowDetail | IBusTuyenDuongCloseDetail |
	IBusTuyenDuongChangeSelectedIds |
	IBusTuyenDuongShowConfirm | IBusTuyenDuongCloseConfirm |
	IBusTuyenDuongSaveStart | IBusTuyenDuongSaveSuccess | IBusTuyenDuongSaveErr |
	IBusTuyenDuongDeleteStart | IBusTuyenDuongDeleteSuccess | IBusTuyenDuongDeleteErr |
	IBusTuyenDuongShowImportModal | IBusTuyenDuongCloseImportModal |
	IBusTuyenDuongValidateImportStart | IBusTuyenDuongValidateImportSuccess | IBusTuyenDuongValidateImportErr |
	IBusTuyenDuongImportStart | IBusTuyenDuongImportSuccess | IBusTuyenDuongImportErr
